import * as d3 from "d3";
import {numberFormat, pieChart} from '../functions'

export default function (chart, divId, vizName,resData) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    console.log("Chart vizName called:", vizName, divId)

    // load the data
    // axios.post(url, filterParam).then(res => {
        let data = resData
        console.log("data is:", data)

        var types = d3.nest()
            .key(function (d) {
                return d.dim1_name
            })
            .entries(data);

        console.log("types", types)

        //  var width = 600, height = 300;
        var svg = d3.select(divId).selectAll("svg").remove();
        svg = d3.select(divId)
            .selectAll('svg')
            .data(types)
            .enter()
            .append('svg')
            .attr('width', chart.width)
            .attr('height', chart.height)
        //   .call(responsivefy)
        // .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        var radius = 100;
        console.log("radius", radius)

        var div = d3.select(divId).append("div").attr("class", "toolTip");

        //    var div2 = d3.select(divId).append("div")

        var g = svg.append("g")
            .attr("transform", "translate(" + chart.width / 2 + "," + chart.height / 1.8 + ")");


        var color = d3.scaleOrdinal().range(pieChart);


        var pie = d3.pie()
            .value(function (d) {
                return d.metric1;
            }).sort(null);


        //   console.log("data2", data2)
        var tots = d3.sum(data, function (d) {
            return d.metric1;
        });

        console.log("tots", tots)

        console.log("datapie", data)

        var path = d3.arc()
            .outerRadius(radius - 5)
            .innerRadius(40);


        var arc = g.selectAll(".arc")
            .data(function (d) {
                return pie(d.values)
            })
            .enter().append("g")
            .attr("class", "arc");


        arc.append("path")
            .attr("d", path)
            .attr("fill", function (d) {
                return color(d.data.dim2_name);
            })
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(d.data.dim2_name + '<br>' +
                    Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + '(' + numberFormat(d.data.metric1) + ' out of ' + numberFormat(tots) + ')')
                    .style("display", "block")
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition()
                    .style("display", "none")
                    .style("opacity", 0)
            });


        var title = svg.append("g")
            .data(types)
            .append("text")
            .attr("x", 150)
            .attr("y", 120)
            .style('text-anchor', 'middle')
            .attr("dominant-baseline", "central")
            .attr('font-weight', 'bold')
            .text(function (d) {
                return d.key + ":" + numberFormat(d.value.metric1)
            })

        console.log(title)


        var legend = svg.append('g')
            .attr("class", "legend")
            .selectAll("g")
            .data(function (d) {
                return pie(d.values)
            }, function (d) {
                return d.data.dim2_name;
            })//setting the data as we know there are only two set of data[programmar/tester] as per the nest function you have written
            .enter().append("g")
            .attr("transform", function (d, i) {
                return "translate(0," + i * 20 + ")";
            });

        legend.append("rect")
            .attr('x', 70)
            .attr('y', 340)
            .attr("width", 18)
            .attr("height", 18)
            .style("fill", function (d) {
                return color(d.data.dim2_name);
            });

        legend.append("text")
            .attr("x", 100)
            .attr("y", 350)
            .attr("dy", ".35em")
            .text(function (d) {
                return Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + '(' + numberFormat(d.data.metric1) + ' out of ' + numberFormat(tots) + ')' + ' ' + d.data.dim2_name;
            });
    // })
}
